import { styled } from 'styled-components';
import { VehicleTag } from '../VehicleTag';

const StyledStatsHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledStatsContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
	margin-top: 18px;
	padding: 17px 20px 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
`;

const StyledVehicleTag = styled(VehicleTag)`
	margin-left: auto;
`;

// const StyledPackSelectionContainer = styled.div`
// 	display: flex;
// 	align-items: center;
// 	justify-content: space-between;
// `;

// const StyledCircularStatsButton = styled(CircularArrowButton)`
// 	background-color: transparent;
// 	border: 1px solid rgba(0, 0, 0, 0.5);

// 	img {
// 		filter: invert(100%);
// 	}

// 	&:hover {
// 		background-color: black;
// 		border-color: black;

// 		img {
// 			filter: none;
// 		}
// 	}
// `;

const StyledVehiclePropertyContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-top: 20px;
`;

export {
	StyledStatsContent,
	StyledStatsHeader,
	StyledVehiclePropertyContainer,
	StyledVehicleTag,
};
